/**
 * Where visitors on non-token routes are sent. Overridable via env so
 * staging/preview can point elsewhere if ever needed.
 */
export const MARKETING_URL = import.meta.env.REACT_APP_MARKETING_URL || "https://miter.com";
